import { render, staticRenderFns } from "./social_h5.vue?vue&type=template&id=55a5d6fe&scoped=true&"
import script from "./social_h5.vue?vue&type=script&lang=js&"
export * from "./social_h5.vue?vue&type=script&lang=js&"
import style0 from "./social_h5.vue?vue&type=style&index=0&id=55a5d6fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5d6fe",
  null
  
)

export default component.exports